import styles from "./Footer.module.scss";

export const Footer = () => {
  return (
    <footer className={styles.footer}>Built on Prometheus © 2023</footer>
  );
};
